import { AdditionalInterestAndInsured } from 'src/configs/APISchemas/Application.schema';

/**
 * Filters out invalid additional insureds from the given array.
 * Should be used when saving additional insureds to the global store.
 * An additional insured is considered invalid if it is undefined or if it is missing
 * any of the required properties (email, firstName, lastName).
 *
 * @param additionalInsureds - The array of additional insureds to filter.
 * @returns The filtered array of valid additional insureds.
 */
export const purgeAdditionalInsuredsForStore = (
  additionalInsureds: Partial<AdditionalInterestAndInsured | undefined>[],
) => {
  return additionalInsureds.filter<AdditionalInterestAndInsured>(
    (additionalInsured): additionalInsured is AdditionalInterestAndInsured => {
      if (!additionalInsured) {
        return false;
      }

      if (
        !additionalInsured.email ||
        !additionalInsured.firstName ||
        !additionalInsured.lastName
      ) {
        return false;
      }

      return true;
    },
  );
};

/**
 * Filters out additional insureds that do not have email, first name, and last name.
 * Should be used when submitting the form to correctly validate the additional insureds.
 * @param additionalInsureds - An array of AdditionalInterestAndInsured objects representing additional insureds.
 * @returns An array of AdditionalInterestAndInsured objects that have email, first name, or last name.
 */
export const purgeAdditionalInsuredsForForm = (
  additionalInsureds: AdditionalInterestAndInsured[],
) => {
  return additionalInsureds.filter((additionalInsured) => {
    if (!additionalInsured) {
      return false;
    }

    if (
      !additionalInsured.email &&
      !additionalInsured.firstName &&
      !additionalInsured.lastName
    ) {
      return false;
    }

    return true;
  });
};
